import DapDSChip from './chip.component'

export * from './chip.component'
export default DapDSChip

DapDSChip.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-chip': DapDSChip
  }
}
